import * as React from "react"
import { useEffect } from "react"
import { array, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { CommonFilters } from "@components"
import { country, disabledCommonFiltersSubmit, isLoadingCommonFilters, retailer } from "@signals"


export default function AdminProductReviewFilters() {

	const { isValid, errors } = useValidatorSeeker({ country: country.value, retailer: retailer.value }, object({
		...(!country.value.length && !retailer.value.length) && {
			country: array().min(1, 'At least one of country be provided'),
			retailer: array().min(1, 'At least one of retailer be provided')
		}
	}))

    useEffect(() => {
        disabledCommonFiltersSubmit.value = !isValid
    }, [isValid]);

	useEffect(() => {
       return () => disabledCommonFiltersSubmit.value = false
    }, []);

	return <CommonFilters
		components={{
			country: true, site: true,
			category: true, brand: true,
			onlySingleDate: true, validated: true,
			normalized: true, productsInStock: true
		}}
		compProps={{
			spaceOnlySingleDate: { grid: { xs: 0, md: 0 } },
			productsInStock: { grid: { md: 9 } },
			country: { grid: { md: 4 }, error: errors?.country},
			site: { grid: { md: 4 }, error: errors?.retailer },
			category: { grid: { md: 4 } },
			brand: { grid: { md: 8 } },
			validated: { grid: { md: 2 } },
			normalized: { grid: { md: 2 } },
		}}
		onSubmit={() => {
			isLoadingCommonFilters.value = true
		}}
	/>
}